<template>
  <div class="afterSale">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "afterSale",
  methods: {
    clearStorage() {
      this.$local.remove("afterSaleToken");
      this.$cookie.remove("afterSaleToken");
    },
  },
  beforeDestroy() {
    this.clearStorage();
  },
  created() {
    // this.clearStorage();
  },
};
</script>

<style lang="scss" scoped>
.afterSale {
  flex: 1;
  display: flex;
  overflow: hidden;
}
</style>
